import { useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import theme from "../../../theme";
import CalendarIcon from "./CalendarIcon";
import CalendarModal from "./CalendarModal";

const Container = styled.div`
  font-family: Spoqa Han Sans Neo;
  background: none;
  display: flex;
`;

const Divider = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const Space = styled.div`
  flex-grow: 0.1;
`;

const Title = styled.div`
  color: ${theme.colors.black};
  margin-bottom: 8px;
`;

const Button = styled.div`
  cursor: pointer;
  border-radius: 5px;
  background-color: ${theme.colors.lightGrey};
  height: 48px;
  padding: 0px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Text = styled.div`
  display: flex;
  color: ${(props) => props.color};
  white-space: nowrap;
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const DateSelect = () => {
  const { startDate, endDate } = useSelector((state) => state.form.schedule);

  const [isVisible, setIsVisible] = useState(false);
  const openModal = () => setIsVisible(true);
  const closeModal = () => setIsVisible(false);

  const formatDate = (date) => {
    if (date.length === 0) return undefined;
    const dateArr = date.split("-");
    const month = Number(dateArr[1]);
    const day = Number(dateArr[2]);
    return `${month}월 ${day}일`;
  };

  const getColor = () => {
    if (startDate && endDate) {
      return theme.colors.black;
    }
    return "#B6B3B3";
  };

  return (
    <Container>
      <CalendarModal isVisible={isVisible} closeModal={closeModal} />
      <Divider>
        <Title>시작일</Title>
        <Button onClick={openModal}>
          <Wrapper>
            <Text color={getColor()}>
              {formatDate(startDate) || "날짜 선택"}
            </Text>
            <CalendarIcon color={getColor()} size={16} />
          </Wrapper>
        </Button>
      </Divider>
      <Space />
      <Divider>
        <Title>종료일</Title>
        <Button onClick={openModal}>
          <Wrapper>
            <Text color={getColor()}>{formatDate(endDate) || "날짜 선택"}</Text>
            <CalendarIcon color={getColor()} size={16} />
          </Wrapper>
        </Button>
      </Divider>
    </Container>
  );
};

export default DateSelect;
